'use strict';

import axios from 'axios';
import config from 'config';

const API_SERVER = config['gaterest_api'] || 'https://gaterest.fxclub.com/real/restapi/quotes';
const request = axios.create({
    baseURL: API_SERVER
});

export function getCurrentQuotes (symbols, lang = 'eng') {
    let symbolsParams = symbols.join(',');
    return request.get('/currentquotes', {params: {symbols: symbolsParams}}).then((response) => {
        return response.data.Result.QuotesTrade;
    });
}

export function getHistoryQuotes (symbol, interval) {
    return request.get('/historyquotes', {params: {symbol, interval}}).then((response) => {
        return response.data.Result.RateHistory;
    });
}



// WEBPACK FOOTER //
// ./src/api/gaterest-sdk.js